<template>
  <div class="downtime-banner" v-if="showDowntimeBanner">
    <Maintenance-Icon />
    <div>
      There will be a scheduled down time on <mark>2nd October</mark> from
      <mark>12.30 AM EDT</mark> to <mark>5.30 AM EDT</mark> to improve our
      infrastructure. During the maintenance window, Adapt platform will be
      inaccessible.
    </div>
    <Close-Icon @click="closeBanner()" />
  </div>
</template>

<script>
import { setCookie, readCookie } from '@/assets/util/commonUtil'
import { DOWNTIME_START } from '@/assets/util/constants/constants.js'
import CloseIcon from '@/assets/icons/svg/close-material.svg'
import MaintenanceIcon from '@/assets/icons/svg/maintenance.svg'

export default {
  name: 'DownTimeBanner',
  data: function () {
    return {
      showDowntimeBanner: false,
    }
  },
  components: {
    'Close-Icon': CloseIcon,
    'Maintenance-Icon': MaintenanceIcon,
  },
  methods: {
    closeBanner() {
      setCookie('downtimeBannerShown', 'true')
      this.setShowDowntimeBanner(false)
    },
    setShowDowntimeBanner(value) {
      this.showDowntimeBanner = value
    },
  },
  mounted: function () {
    const cookieData = readCookie('downtimeBannerShown')
    if (cookieData === null && new Date(DOWNTIME_START) > new Date()) {
      this.setShowDowntimeBanner(true)
    }
  },
}
</script>

<style scoped lang="scss">
.downtime-banner {
  position: sticky;
  top: 51px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(270.03deg, #d4dafd -33.73%, #ffdae7 115.72%);
  font-size: 12px;
  line-height: 19px;
  letter-spacing: 0.05em;
  row-gap: 10px;
  color: rgba(3, 3, 3, 0.75);
  z-index: 111;
  mark {
    font-family: 'Graphik-Medium';
    background: transparent;
    color: rgba(206, 39, 98, 1);
  }
  > div {
    text-align: center;
  }
  svg:last-child {
    cursor: pointer;
    position: absolute;
    right: 12px;
    top: 12px;
  }
}
</style>
